import React from 'react';
import CmsPublicPage from './CmsPublicPage';

const PrivacyPage = () => (
    <CmsPublicPage pageKey="privacy" breadcrumbLabel="Privacy Policy" />
);

export default PrivacyPage;
